/* GarmentGoods theme */
(function () {
  'use strict';
  var d = document.documentElement;
  var GG = window.GG || {};
  var R = GG.routes || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call(((c && c.querySelectorAll) ? c : document).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  var vh = window.innerHeight, vw = window.innerWidth, hh = 51;

  /* preloader, timed like the original: letters rise, hero fades in, wordmark exits upwards */
  if (d.classList.contains('is-intro')) {
    /* start counting from the first paint, so the JS steps line up with the CSS letter animation */
    requestAnimationFrame(function () {
      /* anchor to the real start of the letter animation so every step matches the original timing */
      var first = $('.intro-word span');
      var a0 = (first && first.getAnimations) ? first.getAnimations()[0] : null;
      function schedule(t0) {
        window.GGintroT0 = t0;
        function at(ms, fn) { setTimeout(fn, Math.max(0, t0 + ms - performance.now())); }
        at(920, function () { d.classList.add('intro-leave'); });
        at(1100, function () { d.classList.add('is-revealed'); });
        at(1600, function () { d.classList.add('logo-in'); });
        at(3100, function () {
          d.classList.remove('is-intro', 'is-revealed', 'intro-leave', 'logo-in');
          var i = $('.intro'); if (i && i.parentNode) i.parentNode.removeChild(i);
        });
      }
      if (a0 && a0.ready) {
        a0.ready.then(function () { schedule((typeof a0.startTime === 'number' ? a0.startTime : performance.now()) + 150); })
          .catch(function () { schedule(performance.now() + 150); });
      } else schedule(performance.now() + 150);
    });
  }

  /* smooth scrolling */
  var lenis = null;
  if (!reduce && GG.smooth && window.Lenis) {
    try { lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true }); } catch (e) { lenis = null; }
  }

  /* ticker speed in px per second */
  function tickers(root) {
    $$('[data-ticker]', root).forEach(function (t) {
      var g = t.firstElementChild; if (!g) return;
      var sp = parseFloat(t.getAttribute('data-speed')) || 25;
      t.style.animationDuration = (g.offsetWidth / sp).toFixed(1) + 's';
    });
  }
  tickers();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(tickers);
  window.addEventListener('resize', function () { vh = window.innerHeight; vw = window.innerWidth; tickers(); }, { passive: true });

  /* scroll-driven pieces */
  var pss = [], rts = [], plx = [], io = null;
  function collect() {
    pss = $$('[data-ps]').map(function (el) {
      return { el: el, track: $('[data-ps-track]', el), x: 0,
        len: parseFloat(el.getAttribute('data-len')) || 900,
        lenM: parseFloat(el.getAttribute('data-len-mobile')) || 1400 };
    });
    rts = $$('[data-reveal-text]').map(function (el) { return { el: el, words: $$('.w', el), last: -1 }; });
    plx = GG.parallax === false ? [] : $$('.plx');
  }
  collect();

  function frame() {
    var a, b, j;
    for (a = 0; a < pss.length; a++) {
      var p = pss[a]; if (!p.track) continue;
      var r = p.el.getBoundingClientRect();
      var L = vw < 810 ? p.lenM : p.len;
      var pr = clamp((hh - r.top) / L, 0, 1);
      var target = -pr * Math.max(0, p.track.scrollWidth - vw);
      p.x += (target - p.x) * (reduce ? 1 : 0.14);
      if (Math.abs(target - p.x) < 0.1) p.x = target;
      p.track.style.transform = 'translate3d(' + p.x.toFixed(2) + 'px,0,0)';
    }
    for (b = 0; b < rts.length; b++) {
      var o = rts[b], rr = (o.el.closest('[data-reveal-wrap]') || o.el).getBoundingClientRect();
      /* same as framer-motion useScroll({ offset: ['start 0.85', 'end 0.5'] }) on the text block */
      var wp = clamp((0.85 * vh - rr.top) / (0.35 * vh + rr.height), 0, 1);
      if (rr.bottom < -200 || rr.top > vh + 200) { if (o.last === wp) continue; }
      if (Math.abs(wp - o.last) < 0.0004) continue;
      o.last = wp;
      var n = o.words.length, f = wp * n;
      for (var i = 0; i < n; i++) o.words[i].style.opacity = (0.2 + 0.8 * clamp(f - i, 0, 1)).toFixed(3);
    }
    if (!reduce) {
      var sy = window.scrollY || window.pageYOffset || 0;
      for (j = 0; j < plx.length; j++) {
        var fr = (plx[j].closest('.frame') || plx[j].parentElement).getBoundingClientRect();
        if (fr.bottom < -60 || fr.top > vh + 60) continue;
        /* image drifts from centred to top-aligned while its frame scrolls out */
        var pp = clamp(sy / Math.max(1, fr.top + sy + fr.height), 0, 1);
        plx[j].style.transform = 'translate3d(0,' + (pp * 10).toFixed(3) + '%,0) scale(1.2)';
      }
    }
  }
  function raf(t) { if (lenis) lenis.raf(t); frame(); window.requestAnimationFrame(raf); }
  window.requestAnimationFrame(raf);

  /* hairlines and in-view states */
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
  }
  function lines(root) {
    var watch = $$('.ln-t, .ln-b, .ln-r, .ln-l, [data-inview]', root).filter(function (e) { return !e.classList.contains('in'); });
    if (!io) { watch.forEach(function (l) { l.classList.add('in'); }); return; }
    watch.forEach(function (l) { io.observe(l); });
  }
  setTimeout(function () { lines(); }, d.classList.contains('is-intro') ? 700 : 0);

  /* drawers and dialogs */
  var scrim = $('#Scrim'), openEl = null, lastFocus = null;
  function lock(on) { if (lenis) { if (on) lenis.stop(); else lenis.start(); } document.body.style.overflow = on ? 'hidden' : ''; }
  function setExpanded(id, v) { $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', v); }); }
  function close(silent) {
    if (!openEl) return;
    openEl.classList.remove('open'); openEl.setAttribute('aria-hidden', 'true'); setExpanded(openEl.id, 'false');
    openEl = null; if (scrim) scrim.classList.remove('on', 'deep'); lock(false);
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function open(id) {
    var el = document.getElementById(id); if (!el) return false;
    var prev = openEl ? lastFocus : document.activeElement;
    close(true); lastFocus = prev; openEl = el;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); setExpanded(id, 'true');
    if (scrim && !el.hasAttribute('data-noscrim')) { scrim.classList.toggle('deep', el.hasAttribute('data-deep')); scrim.classList.add('on'); }
    lock(true);
    setTimeout(function () {
      var f = $('[data-autofocus]', el) || $('button, [href], input, select, textarea', el);
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }, 80);
    return true;
  }
  GG.open = open; GG.close = close;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { if (open(o.getAttribute('data-open'))) e.preventDefault(); return; }
    if (e.target.closest('[data-close]') || (scrim && e.target === scrim) || (openEl && openEl.hasAttribute('data-noscrim') && e.target === openEl)) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !openEl) return;
    var f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', openEl).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !openEl.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !openEl.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  if (/[?&]customer_posted=true/.test(window.location.search) && document.getElementById('Newsletter')) open('Newsletter');

  /* money formatting for live search */
  function money(cents) {
    var fmt = GG.moneyFormat || '{{amount}}';
    var v = cents / 100;
    function f(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p[0] + ds + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return f(v, 0, ',', '.');
        case 'amount_with_comma_separator': return f(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(v, 2, "'", '.');
        case 'amount_with_space_separator': return f(v, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return f(v, 0, ' ', ',');
        default: return f(v, 2, ',', '.');
      }
    });
  }

  /* live search */
  var sInput = $('[data-predictive]'), sRes = $('[data-results]'), sTimer = null, sCtrl = null;
  if (sInput && sRes && R.predictive_search_url && window.fetch) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (!q) { sRes.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        if (sCtrl) sCtrl.abort();
        sCtrl = window.AbortController ? new AbortController() : null;
        fetch(R.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', sCtrl ? { signal: sCtrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            sRes.innerHTML = '';
            if (!items.length) {
              var p = document.createElement('p');
              p.textContent = ((GG.strings && GG.strings.noResults) || 'No results for “{q}”').replace('{q}', q);
              sRes.appendChild(p); return;
            }
            items.forEach(function (it) {
              var a = document.createElement('a'); a.href = it.url;
              var b = document.createElement('b'); b.textContent = it.title; a.appendChild(b);
              var cents = Math.round(parseFloat(it.price) * 100);
              if (!isNaN(cents)) { var s = document.createElement('span'); s.innerHTML = money(cents); a.appendChild(s); }
              sRes.appendChild(a);
            });
            var all = document.createElement('a'); all.className = 's-all';
            all.href = R.search_url + '?q=' + encodeURIComponent(q) + '&type=product';
            all.textContent = (GG.strings && GG.strings.viewAll) || 'View all';
            sRes.appendChild(all);
          })
          .catch(function () {});
      }, 180);
    });
  }

  /* cart drawer */
  function applyCart(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var inner = $('[data-cart-inner]', tmp), cur = $('[data-cart-inner]');
    if (inner && cur) {
      cur.parentNode.replaceChild(inner, cur);
      var n = inner.getAttribute('data-count') || '0';
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('pform') || !window.fetch) return;
    e.preventDefault();
    var btn = $('[type="submit"]', f), err = $('[data-form-error]', f);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (err) { err.hidden = true; err.textContent = ''; }
    var fd = new FormData(f);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(R.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Error'; err.hidden = false; } return; }
        applyCart(res.j.sections && res.j.sections['cart-drawer']);
        /* theme setting "After 'Add to Bag'": open the bag, or (like the original) only update the count */
        if (GG.cartAdd === 'drawer') open('CartDrawer');
        /* one-offs switch to sold out */
        var stock = btn ? parseInt(btn.getAttribute('data-stock'), 10) : NaN;
        if (btn && !isNaN(stock) && (res.j.quantity || 0) >= stock) {
          btn.textContent = btn.getAttribute('data-soldout') || 'Out of Stock';
          btn.classList.remove('pill--dark'); btn.setAttribute('data-done', '1');
        }
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.hasAttribute('data-done'); } });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-line]');
    if (!rm || !window.fetch) return;
    e.preventDefault();
    fetch(R.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(rm.getAttribute('data-remove-line'), 10), quantity: 0, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        applyCart(j.sections && j.sections['cart-drawer']);
      })
      .catch(function () { window.location.href = rm.getAttribute('href'); });
  });

  /* quote slider */
  function quotes(root) {
  $$('[data-quotes]', root).forEach(function (qs) {
    if (qs.dataset.ready) return; qs.dataset.ready = '1';
    var t = $('[data-q-track]', qs), n = t ? t.children.length : 0, i = 0;
    if (n < 2) return;
    function go(k) { i = (k + n) % n; t.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)'; }
    var p = $('[data-q-prev]', qs), x = $('[data-q-next]', qs);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (x) x.addEventListener('click', function () { go(i + 1); });
    var sx = null;
    qs.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    qs.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); });
    /* optional autoplay (section setting), pauses while hovered or focused */
    var every = parseInt(qs.getAttribute('data-autoplay'), 10), hold = false;
    if (every > 0 && !reduce) {
      qs.addEventListener('mouseenter', function () { hold = true; });
      qs.addEventListener('mouseleave', function () { hold = false; });
      qs.addEventListener('focusin', function () { hold = true; });
      qs.addEventListener('focusout', function () { hold = false; });
      setInterval(function () { if (!hold && !document.hidden && document.body.contains(qs)) go(i + 1); }, every);
    }
  });
  }
  quotes();

  /* quantity stepper */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var wrap = b.closest('.qty'), inp = wrap && $('input', wrap); if (!inp) return;
    var max = parseInt(inp.getAttribute('max'), 10) || 99;
    inp.value = clamp((parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10), 1, max);
  });

  /* product gallery arrows */
  function galleries(root) {
  $$('[data-gallery]', root).forEach(function (g) {
    if (g.dataset.ready) return; g.dataset.ready = '1';
    var tr = $('[data-gal-track]', g); if (!tr) return;
    $$('[data-gal]', g).forEach(function (b) {
      b.addEventListener('click', function () { tr.scrollBy({ left: tr.clientWidth * parseInt(b.getAttribute('data-gal'), 10), behavior: reduce ? 'auto' : 'smooth' }); });
    });
    var cnt = $('[data-gal-count]', g), total = tr.children.length;
    if (cnt) tr.addEventListener('scroll', function () {
      cnt.textContent = (clamp(Math.round(tr.scrollLeft / (tr.clientWidth || 1)), 0, total - 1) + 1) + ' / ' + total;
    }, { passive: true });
  });
  lightbox(root);
  }

  /* fullscreen gallery: click to zoom in at the pointer, move to pan */
  function lightbox(root) {
    var lb = $('[data-lb]', root && root.querySelector ? root : document);
    if (!lb || lb.dataset.ready || !lb.showModal) return; lb.dataset.ready = '1';
    var tr = $('[data-lb-track]', lb), cnt = $('[data-lb-count]', lb), slides = $$('[data-lb-slide]', lb);
    var gtr = $('[data-gal-track]'), n = slides.length, idx = 0;
    function cur() { return clamp(Math.round(tr.scrollLeft / (tr.clientWidth || 1)), 0, n - 1); }
    function unzoom() { slides.forEach(function (s) { s.classList.remove('z', 'pan'); }); tr.classList.remove('zoomed'); }
    function go(i, smooth) { unzoom(); idx = clamp(i, 0, n - 1); tr.scrollTo({ left: idx * tr.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' }); }
    function origin(s, x, y) {
      var r = $('img', s).getBoundingClientRect();
      s.style.setProperty('--ox', (clamp((x - r.left) / r.width, 0, 1) * 100).toFixed(2) + '%');
      s.style.setProperty('--oy', (clamp((y - r.top) / r.height, 0, 1) * 100).toFixed(2) + '%');
    }
    tr.addEventListener('scroll', function () { if (cnt) cnt.textContent = (cur() + 1) + ' / ' + n; }, { passive: true });
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-lb-open]'); if (!o) return;
      lb.showModal();
      if (lenis) lenis.stop(); else d.style.overflow = 'hidden';
      go(parseInt(o.getAttribute('data-lb-open'), 10) || 0, false);
      if (cnt) cnt.textContent = (idx + 1) + ' / ' + n;
    });
    lb.addEventListener('close', function () {
      var i = cur(); unzoom();
      if (lenis) lenis.start(); else d.style.overflow = '';
      if (gtr) gtr.scrollLeft = i * gtr.clientWidth;
    });
    $$('[data-lb-close]', lb).forEach(function (b) { b.addEventListener('click', function () { lb.close(); }); });
    $$('[data-lb-go]', lb).forEach(function (b) { b.addEventListener('click', function () { go(cur() + parseInt(b.getAttribute('data-lb-go'), 10), true); }); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur() + (e.key === 'ArrowRight' ? 1 : -1), true); }
    });
    /* tap/click toggles zoom; moving (mouse hover or a pressed finger) pans */
    var down = null, moved = false;
    slides.forEach(function (s) {
      s.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; moved = false; });
      s.addEventListener('pointermove', function (e) {
        if (down && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 8) moved = true;
        if (!s.classList.contains('z')) return;
        if (e.pointerType === 'mouse' || down) { s.classList.add('pan'); origin(s, e.clientX, e.clientY); }
      });
      s.addEventListener('pointerup', function () { down = null; });
      s.addEventListener('click', function (e) {
        if (moved) { moved = false; return; }
        if (s.classList.contains('z')) { unzoom(); return; }
        s.classList.remove('pan'); origin(s, e.clientX, e.clientY);
        s.classList.add('z'); tr.classList.add('zoomed');
      });
    });
  }
  galleries();

  /* sticky buy bar on phones: shows once the real buy row is out of view */
  var sb = $('[data-sbar]');
  if (sb) {
    var buyRow = $('.row--buy'), mainAdd = buyRow && $('[name="add"]', buyRow), sbAdd = $('[data-sbar-add]', sb), sbOn = false, sbT = 0;
    if (mainAdd && sbAdd) {
      sbAdd.addEventListener('click', function () { mainAdd.click(); });
      new MutationObserver(function () {
        sbAdd.textContent = mainAdd.textContent; sbAdd.disabled = mainAdd.disabled;
        sbAdd.classList.toggle('pill--dark', mainAdd.classList.contains('pill--dark'));
      }).observe(mainAdd, { attributes: true, childList: true, characterData: true, subtree: true });
      var sbCheck = function () {
        sbT = 0;
        var r = buyRow.getBoundingClientRect();
        var on = window.innerWidth < 810 && (window.scrollY || window.pageYOffset) > 60 && (r.top > window.innerHeight || r.bottom < hh);
        if (on === sbOn) return; sbOn = on;
        sb.classList.toggle('on', on); sb.inert = !on;
        document.body.classList.toggle('sbar-on', on);
      };
      window.addEventListener('scroll', function () { if (!sbT) sbT = requestAnimationFrame(sbCheck); }, { passive: true });
      window.addEventListener('resize', sbCheck, { passive: true });
      sbCheck();
    }
  }

  /* language switch and variant select */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-autosubmit]') && t.form) t.form.submit();
    if (t.matches && t.matches('[data-sort]')) {
      var su = new URL(window.location.href); su.searchParams.set('sort_by', t.value); su.searchParams.delete('page'); window.location.href = su.toString();
    }
    if (t.classList && t.classList.contains('vsel')) {
      var u = new URL(window.location.href); u.searchParams.set('variant', t.value); window.location.href = u.toString();
    }
  });

  /* filter pills (stockists) */
  function filters(root) {
  $$('[data-filter]', root).forEach(function (bar) {
    if (bar.dataset.ready) return; bar.dataset.ready = '1';
    var pills = $$('[data-filter-value]', bar), sec = bar.nextElementSibling;
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var v = p.getAttribute('data-filter-value');
        pills.forEach(function (q) { q.classList.toggle('is-active', q === p); });
        if (sec) $$('[data-region]', sec).forEach(function (c) { c.hidden = !!v && c.getAttribute('data-region') !== v; });
      });
    });
  });
  }
  filters();

  /* Shopify theme editor: rebuild everything when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    collect(); tickers(); lines(e.target); quotes(e.target); filters(e.target); galleries(e.target);
  });

  /* "Discover" cursor over large images */
  var cur = $('#Cursor');
  if (fine && cur) {
    window.addEventListener('mousemove', function (e) { cur.style.left = e.clientX + 'px'; cur.style.top = e.clientY + 'px'; }, { passive: true });
    document.addEventListener('mouseover', function (e) { cur.classList.toggle('on', !!(e.target.closest && e.target.closest('.discover'))); });
  }
})();
